import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/feedback/page.tsx");
